webpackJsonp([214960607037312],{

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(648));
	
	var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(651));
	
	var _CheckBox = _interopRequireDefault(__webpack_require__(650));
	
	var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(652));
	
	var _helpers = __webpack_require__(62);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: '#293e60',
	      "&:hover": {
	        color: '#967540'
	      }
	    },
	
	    /* Styles applied to the root element if `checked={true}`. */
	    checked: {
	      color: '#293e60',
	      "&:hover": {
	        color: '#967540'
	      }
	    },
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Checkbox(props) {
	  var checkedIcon = props.checkedIcon,
	    classes = props.classes,
	    color = props.color,
	    icon = props.icon,
	    indeterminate = props.indeterminate,
	    indeterminateIcon = props.indeterminateIcon,
	    other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon"]);
	  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "checkbox",
	    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
	    classes: {
	      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    icon: indeterminate ? indeterminateIcon : icon
	  }, other));
	}
	
	Checkbox.propTypes =  false ? {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the component appears indeterminate.
	   */
	  indeterminate: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is indeterminate.
	   */
	  indeterminateIcon: _propTypes.default.node,
	
	  /**
	   * Properties applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.checked`.
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input component property `type`.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.string
	} : {};
	Checkbox.defaultProps = {
	  checkedIcon: _react.default.createElement(_CheckBox.default, null),
	  color: 'secondary',
	  icon: _react.default.createElement(_CheckBoxOutlineBlank.default, null),
	  indeterminate: false,
	  indeterminateIcon: _react.default.createElement(_IndeterminateCheckBox.default, null)
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCheckbox'
	})(Checkbox);
	
	exports.default = _default;

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(597));

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _helpers = __webpack_require__(62);
	
	var SIZE = 44;
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return (clampedValue - min) / (max - min);
	}
	
	function easeOut(t) {
	  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294
	
	  t = (t -= 1) * t * t + 1;
	  return t;
	}
	
	function easeIn(t) {
	  return t * t;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-block',
	      lineHeight: 1 // Keep the progress centered
	
	    },
	
	    /* Styles applied to the root element if `variant="static"`. */
	    static: {
	      transition: theme.transitions.create('transform')
	    },
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {
	      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the `svg` element. */
	    svg: {},
	
	    /* Styles applied to the `circle` svg path. */
	    circle: {
	      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
	      // strokeLinecap: 'butt',
	
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="static"`. */
	    circleStatic: {
	      transition: theme.transitions.create('stroke-dashoffset')
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
	    circleIndeterminate: {
	      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
	      // Some default value that looks fine waiting for the animation to kicks in.
	      strokeDasharray: '80px, 200px',
	      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
	
	    },
	    '@keyframes mui-progress-circular-rotate': {
	      '100%': {
	        transform: 'rotate(360deg)'
	      }
	    },
	    '@keyframes mui-progress-circular-dash': {
	      '0%': {
	        strokeDasharray: '1px, 200px',
	        strokeDashoffset: '0px'
	      },
	      '50%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-15px'
	      },
	      '100%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-120px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	
	function CircularProgress(props) {
	  var _classNames, _classNames2;
	
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      size = props.size,
	      style = props.style,
	      thickness = props.thickness,
	      value = props.value,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "size", "style", "thickness", "value", "variant"]);
	  var circleStyle = {};
	  var rootStyle = {};
	  var rootProps = {};
	
	  if (variant === 'determinate' || variant === 'static') {
	    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
	    circleStyle.strokeDasharray = circumference.toFixed(3);
	    rootProps['aria-valuenow'] = Math.round(value);
	
	    if (variant === 'static') {
	      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
	      rootStyle.transform = 'rotate(-90deg)';
	    } else {
	      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
	      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
	    }
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes.indeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames, classes.static, variant === 'static'), _classNames), className),
	    style: (0, _extends2.default)({
	      width: size,
	      height: size
	    }, rootStyle, style),
	    role: "progressbar"
	  }, rootProps, other), _react.default.createElement("svg", {
	    className: classes.svg,
	    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
	  }, _react.default.createElement("circle", {
	    className: (0, _classnames.default)(classes.circle, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.circleIndeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames2, classes.circleStatic, variant === 'static'), _classNames2)),
	    style: circleStyle,
	    cx: SIZE,
	    cy: SIZE,
	    r: (SIZE - thickness) / 2,
	    fill: "none",
	    strokeWidth: thickness
	  })));
	}
	
	CircularProgress.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'inherit']),
	
	  /**
	   * The size of the circle.
	   */
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The thickness of the circle.
	   */
	  thickness: _propTypes.default.number,
	
	  /**
	   * The value of the progress indicator for the determinate and static variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
	} : {};
	CircularProgress.defaultProps = {
	  color: 'primary',
	  size: 40,
	  thickness: 3.6,
	  value: 0,
	  variant: 'indeterminate'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCircularProgress',
	  flip: false
	})(CircularProgress);
	
	exports.default = _default;

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	
	var _CircularProgress = _interopRequireDefault(__webpack_require__(254));

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _Typography = _interopRequireDefault(__webpack_require__(376));
	
	/* eslint-disable jsx-a11y/label-has-for */
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      cursor: 'pointer',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      marginLeft: -14,
	      marginRight: 16,
	      // used for row presentation of radio/checkbox
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if `labelPlacement="start"`. */
	    labelPlacementStart: {
	      flexDirection: 'row-reverse'
	    },
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the label's Typography component. */
	    label: {
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    }
	  };
	};
	/**
	 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
	 * Use this component if you want to display an extra label.
	 */
	
	
	exports.styles = styles;
	
	function FormControlLabel(props, context) {
	  var _classNames;
	
	  var checked = props.checked,
	      classes = props.classes,
	      classNameProp = props.className,
	      control = props.control,
	      disabledProp = props.disabled,
	      inputRef = props.inputRef,
	      label = props.label,
	      labelPlacement = props.labelPlacement,
	      name = props.name,
	      onChange = props.onChange,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);
	  var muiFormControl = context.muiFormControl;
	  var disabled = disabledProp;
	
	  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
	    disabled = control.props.disabled;
	  }
	
	  if (typeof disabled === 'undefined' && muiFormControl) {
	    disabled = muiFormControl.disabled;
	  }
	
	  var controlProps = {
	    disabled: disabled
	  };
	  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
	    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
	      controlProps[key] = props[key];
	    }
	  });
	  return _react.default.createElement("label", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.labelPlacementStart, labelPlacement === 'start'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp)
	  }, other), _react.default.cloneElement(control, controlProps), _react.default.createElement(_Typography.default, {
	    component: "span",
	    className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.disabled, disabled))
	  }, label));
	}
	
	FormControlLabel.propTypes =  false ? {
	  /**
	   * If `true`, the component appears selected.
	   */
	  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
	   */
	  control: _propTypes.default.element,
	
	  /**
	   * If `true`, the control will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * The text to be used in an enclosing label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The position of the label.
	   */
	  labelPlacement: _propTypes.default.oneOf(['end', 'start']),
	
	  /*
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.checked`.
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.string
	} : {};
	FormControlLabel.defaultProps = {
	  labelPlacement: 'end'
	};
	FormControlLabel.contextTypes = {
	  muiFormControl: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControlLabel'
	})(FormControlLabel);
	
	exports.default = _default;

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControlLabel.default;
	  }
	});
	
	var _FormControlLabel = _interopRequireDefault(__webpack_require__(606));

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    flexWrap: 'wrap'
	  },
	
	  /* Styles applied to the root element if `row={true}`. */
	  row: {
	    flexDirection: 'row'
	  }
	};
	/**
	 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
	 * It provides compact row layout.
	 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
	 */
	
	exports.styles = styles;
	
	function FormGroup(props) {
	  var classes = props.classes,
	      className = props.className,
	      children = props.children,
	      row = props.row,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "children", "row"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.row, row), className)
	  }, other), children);
	}
	
	FormGroup.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Display group of elements in a compact row.
	   */
	  row: _propTypes.default.bool
	} : {};
	FormGroup.defaultProps = {
	  row: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormGroup'
	})(FormGroup);
	
	exports.default = _default;

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup.default;
	  }
	});
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(608));

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _colorManipulator = __webpack_require__(151);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(190));
	
	var _helpers = __webpack_require__(62);
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      width: 48,
	      height: 48,
	      padding: 0,
	      borderRadius: '50%',
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the children container element. */
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/style/icons) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	
	function IconButton(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      disabled = props.disabled,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
	    centerRipple: true,
	    focusRipple: true,
	    disabled: disabled
	  }, other), _react.default.createElement("span", {
	    className: classes.label
	  }, children));
	}
	
	IconButton.propTypes =  false ? {
	  /**
	   * The icon element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple will be disabled.
	   */
	  disableRipple: _propTypes.default.bool
	} : {};
	IconButton.defaultProps = {
	  color: 'default',
	  disabled: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(257));

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _helpers = __webpack_require__(62);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      margin: 0
	    },
	
	    /* Styles applied to the root element if `variant="display4"`. */
	    display4: theme.typography.display4,
	
	    /* Styles applied to the root element if `variant="display3"`. */
	    display3: theme.typography.display3,
	
	    /* Styles applied to the root element if `variant="display2"`. */
	    display2: theme.typography.display2,
	
	    /* Styles applied to the root element if `variant="display1"`. */
	    display1: theme.typography.display1,
	
	    /* Styles applied to the root element if `variant="headline"`. */
	    headline: theme.typography.headline,
	
	    /* Styles applied to the root element if `variant="title"`. */
	    title: theme.typography.title,
	
	    /* Styles applied to the root element if `variant="subheading"`. */
	    subheading: theme.typography.subheading,
	
	    /* Styles applied to the root element if `variant="body2"`. */
	    body2: theme.typography.body2,
	
	    /* Styles applied to the root element if `variant="body1"`. */
	    body1: theme.typography.body1,
	
	    /* Styles applied to the root element if `variant="caption"`. */
	    caption: theme.typography.caption,
	
	    /* Styles applied to the root element if `variant="button"`. */
	    button: theme.typography.button,
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `align="nowrap"`. */
	    noWrap: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `gutterBottom={true}`. */
	    gutterBottom: {
	      marginBottom: '0.35em'
	    },
	
	    /* Styles applied to the root element if `paragraph={true}`. */
	    paragraph: {
	      marginBottom: 16
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="textPrimary"`. */
	    colorTextPrimary: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `color="textSecondary"`. */
	    colorTextSecondary: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Typography(props) {
	  var _classNames;
	
	  var align = props.align,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      componentProp = props.component,
	      gutterBottom = props.gutterBottom,
	      headlineMapping = props.headlineMapping,
	      noWrap = props.noWrap,
	      paragraph = props.paragraph,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "gutterBottom", "headlineMapping", "noWrap", "paragraph", "variant"]);
	  var className = (0, _classnames.default)(classes.root, classes[variant], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty2.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty2.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty2.default)(_classNames, classes["align".concat((0, _helpers.capitalize)(align))], align !== 'inherit'), _classNames), classNameProp);
	  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant]) || 'span';
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other));
	}
	
	Typography.propTypes =  false ? {
	  /**
	   * Set the text-align on the component.
	   */
	  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it maps the variant to a good default headline component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  gutterBottom: _propTypes.default.bool,
	
	  /**
	   * We are empirically mapping the variant property to a range of different DOM element types.
	   * For instance, h1 to h6. If you wish to change that mapping, you can provide your own.
	   * Alternatively, you can use the `component` property.
	   */
	  headlineMapping: _propTypes.default.object,
	
	  /**
	   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
	   */
	  noWrap: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  paragraph: _propTypes.default.bool,
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])
	} : {};
	Typography.defaultProps = {
	  align: 'inherit',
	  color: 'default',
	  gutterBottom: false,
	  headlineMapping: {
	    display4: 'h1',
	    display3: 'h1',
	    display2: 'h1',
	    display1: 'h1',
	    headline: 'h1',
	    title: 'h2',
	    subheading: 'h3',
	    body2: 'aside',
	    body1: 'p'
	  },
	  noWrap: false,
	  paragraph: false,
	  variant: 'body1'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTypography'
	})(Typography);
	
	exports.default = _default;

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	
	var _Typography = _interopRequireDefault(__webpack_require__(642));

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(9));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(12));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(11));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(87));
	
	// @inheritedComponent IconButton
	var styles = {
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    transition: 'none',
	    '&:hover': {
	      // Disable the hover effect for the IconButton.
	      backgroundColor: 'transparent'
	    }
	  },
	  checked: {},
	  disabled: {},
	  input: {
	    cursor: 'inherit',
	    position: 'absolute',
	    opacity: 0,
	    width: '100%',
	    height: '100%',
	    top: 0,
	    left: 0,
	    margin: 0,
	    padding: 0
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	
	var SwitchBase =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(SwitchBase, _React$Component);
	
	  function SwitchBase(props) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, SwitchBase);
	    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SwitchBase).call(this));
	    _this.input = null;
	    _this.isControlled = null;
	    _this.state = {};
	
	    _this.handleFocus = function (event) {
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	
	      var muiFormControl = _this.context.muiFormControl;
	
	      if (muiFormControl && muiFormControl.onFocus) {
	        muiFormControl.onFocus(event);
	      }
	    };
	
	    _this.handleBlur = function (event) {
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	
	      var muiFormControl = _this.context.muiFormControl;
	
	      if (muiFormControl && muiFormControl.onBlur) {
	        muiFormControl.onBlur(event);
	      }
	    };
	
	    _this.handleInputChange = function (event) {
	      var checked = event.target.checked;
	
	      if (!_this.isControlled) {
	        _this.setState({
	          checked: checked
	        });
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event, checked);
	      }
	    };
	
	    _this.isControlled = props.checked != null;
	
	    if (!_this.isControlled) {
	      // not controlled, use internal state
	      _this.state.checked = props.defaultChecked !== undefined ? props.defaultChecked : false;
	    }
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(SwitchBase, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          autoFocus = _this$props.autoFocus,
	          checkedProp = _this$props.checked,
	          checkedIcon = _this$props.checkedIcon,
	          classes = _this$props.classes,
	          classNameProp = _this$props.className,
	          disabledProp = _this$props.disabled,
	          icon = _this$props.icon,
	          id = _this$props.id,
	          inputProps = _this$props.inputProps,
	          inputRef = _this$props.inputRef,
	          name = _this$props.name,
	          onBlur = _this$props.onBlur,
	          onChange = _this$props.onChange,
	          onFocus = _this$props.onFocus,
	          readOnly = _this$props.readOnly,
	          required = _this$props.required,
	          tabIndex = _this$props.tabIndex,
	          type = _this$props.type,
	          value = _this$props.value,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);
	      var muiFormControl = this.context.muiFormControl;
	      var disabled = disabledProp;
	
	      if (muiFormControl) {
	        if (typeof disabled === 'undefined') {
	          disabled = muiFormControl.disabled;
	        }
	      }
	
	      var checked = this.isControlled ? checkedProp : this.state.checked;
	      var hasLabelFor = type === 'checkbox' || type === 'radio';
	      return _react.default.createElement(_IconButton.default, (0, _extends2.default)({
	        component: "span",
	        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.checked, checked), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp),
	        disabled: disabled,
	        tabIndex: null,
	        role: undefined,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }, other), checked ? checkedIcon : icon, _react.default.createElement("input", (0, _extends2.default)({
	        autoFocus: autoFocus,
	        checked: checked,
	        className: classes.input,
	        disabled: disabled,
	        id: hasLabelFor && id,
	        name: name,
	        onChange: this.handleInputChange,
	        readOnly: readOnly,
	        ref: inputRef,
	        required: required,
	        tabIndex: tabIndex,
	        type: type,
	        value: value
	      }, inputProps)));
	    }
	  }]);
	  return SwitchBase;
	}(_react.default.Component); // NB: If changed, please update Checkbox, Switch and Radio
	// so that the API documentation is updated.
	
	
	SwitchBase.propTypes =  false ? {
	  /**
	   * If `true`, the input will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node.isRequired,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the component appears indeterminate.
	   */
	  indeterminate: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is indeterminate.
	   */
	  indeterminateIcon: _propTypes.default.node,
	
	  /**
	   * Attributes applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	
	  /*
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.checked`.
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The input component property `type`.
	   */
	  type: _propTypes.default.string.isRequired,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.string
	} : {};
	SwitchBase.contextTypes = {
	  muiFormControl: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSwitchBase'
	})(SwitchBase);
	
	exports.default = _default;

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _pure = _interopRequireDefault(__webpack_require__(124));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(103));
	
	var _ref = _react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var CheckBox = function CheckBox(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	CheckBox = (0, _pure.default)(CheckBox);
	CheckBox.muiName = 'SvgIcon';
	var _default = CheckBox;
	exports.default = _default;

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _pure = _interopRequireDefault(__webpack_require__(124));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(103));
	
	var _ref = _react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	CheckBoxOutlineBlank = (0, _pure.default)(CheckBoxOutlineBlank);
	CheckBoxOutlineBlank.muiName = 'SvgIcon';
	var _default = CheckBoxOutlineBlank;
	exports.default = _default;

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _pure = _interopRequireDefault(__webpack_require__(124));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(103));
	
	var _ref = _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	IndeterminateCheckBox = (0, _pure.default)(IndeterminateCheckBox);
	IndeterminateCheckBox.muiName = 'SvgIcon';
	var _default = IndeterminateCheckBox;
	exports.default = _default;

/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var combineHeaders = function combineHeaders() {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return Object.keys(params).map(function (key) {
	    return key + '=' + encodeURIComponent(params[key]);
	  }).join('&');
	};
	
	var createContactLink = function createContactLink(tel, sms, facetime, email, headers) {
	  var link = void 0;
	  if (email) {
	    link = 'mailto:' + email;
	    if (headers) {
	      link += '?' + combineHeaders(headers);
	    }
	  } else if (tel) {
	    link = 'tel:' + tel;
	  } else if (sms) {
	    link = 'sms:' + sms;
	  } else if (facetime) {
	    link = 'facetime:' + facetime;
	  }
	  return link;
	};
	
	var Obfuscate = function (_Component) {
	  _inherits(Obfuscate, _Component);
	
	  function Obfuscate(props) {
	    _classCallCheck(this, Obfuscate);
	
	    var _this = _possibleConstructorReturn(this, (Obfuscate.__proto__ || Object.getPrototypeOf(Obfuscate)).call(this, props));
	
	    _this.state = {
	      humanInteraction: false
	    };
	    return _this;
	  }
	
	  _createClass(Obfuscate, [{
	    key: 'render',
	    value: function render() {
	      return this.props.obfuscate === false ? this.renderLink() : this.renderObfuscatedLink();
	    }
	  }, {
	    key: 'renderLink',
	    value: function renderLink() {
	      var _props = this.props,
	          tel = _props.tel,
	          sms = _props.sms,
	          facetime = _props.facetime,
	          email = _props.email,
	          obfuscate = _props.obfuscate,
	          headers = _props.headers,
	          children = _props.children,
	          others = _objectWithoutProperties(_props, ['tel', 'sms', 'facetime', 'email', 'obfuscate', 'headers', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          href: createContactLink(tel, sms, facetime, email, headers)
	        }, others),
	        children || tel || sms || facetime || email
	      );
	    }
	  }, {
	    key: 'reverse',
	    value: function reverse(s) {
	      return s.split('').reverse().join('');
	    }
	  }, {
	    key: 'renderObfuscatedLink',
	    value: function renderObfuscatedLink() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          tel = _props2.tel,
	          sms = _props2.sms,
	          facetime = _props2.facetime,
	          email = _props2.email,
	          obfuscate = _props2.obfuscate,
	          headers = _props2.headers,
	          children = _props2.children,
	          style = _props2.style,
	          linkText = _props2.linkText,
	          others = _objectWithoutProperties(_props2, ['tel', 'sms', 'facetime', 'email', 'obfuscate', 'headers', 'children', 'style', 'linkText']);
	
	      var obsStyle = this.state.humanInteraction === true || children ? _extends({}, style || {}, {
	        unicodeBidi: 'bidi-override',
	        display: 'inline-block',
	        direction: 'ltr'
	      }) : _extends({}, style || {}, {
	        unicodeBidi: 'bidi-override',
	        display: 'inline-block',
	        direction: 'rtl'
	      });
	
	      var link = function link(state) {
	        return _this2.state.humanInteraction === true ? children || tel || sms || facetime || email : children || _this2.reverse(tel || sms || facetime || email).replace('(', ')').replace(')', '(');
	      };
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          onClick: this.handleClick.bind(this),
	          onFocus: this.handleCopiability.bind(this),
	          onMouseOver: this.handleCopiability.bind(this),
	          onContextMenu: this.handleCopiability.bind(this),
	          href: linkText || 'obfuscated'
	        }, others, {
	          style: obsStyle
	        }),
	        link()
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      var _props3 = this.props,
	          tel = _props3.tel,
	          sms = _props3.sms,
	          facetime = _props3.facetime,
	          email = _props3.email,
	          headers = _props3.headers;
	
	      window.location.href = createContactLink(tel, sms, facetime, email, headers);
	    }
	  }, {
	    key: 'handleCopiability',
	    value: function handleCopiability() {
	      this.setState(function (state) {
	        return _extends({}, state, {
	          humanInteraction: true
	        });
	      });
	    }
	  }]);
	
	  return Obfuscate;
	}(_react.Component);
	
	exports.default = Obfuscate;

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(14);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _FormLabel = __webpack_require__(371);
	
	var _FormLabel2 = _interopRequireDefault(_FormLabel);
	
	var _FormControl = __webpack_require__(370);
	
	var _FormControl2 = _interopRequireDefault(_FormControl);
	
	var _FormGroup = __webpack_require__(609);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormControlLabel = __webpack_require__(607);
	
	var _FormControlLabel2 = _interopRequireDefault(_FormControlLabel);
	
	var _Checkbox = __webpack_require__(598);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Button = __webpack_require__(189);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Typography = __webpack_require__(376);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _CircularProgress = __webpack_require__(255);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	    return {
	        root: {
	            display: 'flex'
	        },
	        formControl: {
	            margin: '1em'
	        },
	        gbutton: {
	            backgroundColor: theme.main.colors.link,
	            margin: "3em 0",
	            marginLeft: "5em"
	        },
	        label: {
	            color: theme.main.colors.link,
	            "&:hover": {
	                color: theme.main.colors.linkHover
	            }
	        },
	        flabel: {
	            marginTop: '.5em',
	            marginBottom: '.5em'
	        }
	    };
	};
	
	var CatList = function (_React$Component) {
	    _inherits(CatList, _React$Component);
	
	    function CatList() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CatList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.handleAll = function (e) {
	            if (e.target.checked === true) {
	                Object.keys(_this.state).map(function (cat) {
	                    _this.setState(function (prevState) {
	                        var _extends2;
	
	                        return _extends({}, prevState, (_extends2 = {}, _extends2[cat] = true, _extends2));
	                    });
	                });
	            } else {
	                _this.setState(function (prevState) {
	                    return _extends({}, prevState, {
	                        All: false
	                    });
	                });
	            }
	        }, _this.handleChange = function (name) {
	            return function (e) {
	                if (e.target.checked === false) {
	                    _this.setState(function (prevState) {
	                        var _extends3;
	
	                        return _extends({}, prevState, (_extends3 = {
	                            All: false
	                        }, _extends3[name] = false, _extends3));
	                    });
	                } else {
	                    _this.setState(function (prevState) {
	                        var _extends4;
	
	                        return _extends({}, prevState, (_extends4 = {}, _extends4[name] = true, _extends4));
	                    });
	                }
	            };
	        }, _this.getSelected = function () {
	            var selected = [];
	            for (var cat in _this.state) {
	                if (_this.state[cat] == true) {
	                    selected.push(cat);
	                }
	            }
	            _this.props.add(selected);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    CatList.prototype.componentDidMount = function componentDidMount() {
	        var cats = { All: true };
	        this.props.edges.map(function (edge) {
	            var cat = edge.node.frontmatter.category;
	            cats[cat] = true;
	        });
	        this.setState(cats);
	    };
	
	    CatList.prototype.render = function render() {
	        var _this2 = this;
	
	        var classes = this.props.classes;
	
	        var state = this.state;
	
	        return _react2.default.createElement(
	            'div',
	            { className: classes.root },
	            Object.keys(state).length === 0 ? _react2.default.createElement(_CircularProgress2.default, null) : _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _FormControl2.default,
	                    { component: 'fieldset', className: classes.formControl },
	                    _react2.default.createElement(
	                        _FormLabel2.default,
	                        { className: classes.flabel, component: 'legend' },
	                        'Categories'
	                    ),
	                    _react2.default.createElement(
	                        _FormGroup2.default,
	                        null,
	                        _react2.default.createElement(_FormControlLabel2.default, {
	                            control: _react2.default.createElement(_Checkbox2.default, { color: 'default', checked: state.All, onChange: this.handleAll, value: 'All' }),
	                            label: _react2.default.createElement(
	                                _Typography2.default,
	                                { className: classes.label },
	                                'All'
	                            ),
	                            className: classes.item
	                        }),
	                        state && Object.keys(state).map(function (cat, i) {
	                            return cat !== 'All' ? _react2.default.createElement(_FormControlLabel2.default, {
	                                control: _react2.default.createElement(_Checkbox2.default, { color: 'default', checked: state[cat], onChange: _this2.handleChange(cat), value: cat }),
	                                label: _react2.default.createElement(
	                                    _Typography2.default,
	                                    { className: classes.label },
	                                    cat
	                                ),
	                                className: classes.item,
	                                key: i
	                            }) : _react2.default.createElement('div', { key: i });
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Button2.default,
	                    {
	                        variant: 'raised',
	                        color: 'primary',
	                        size: 'large',
	                        type: 'submit',
	                        className: classes.gbutton,
	                        onClick: this.getSelected
	                    },
	                    'Get ID'
	                )
	            )
	        );
	    };
	
	    return CatList;
	}(_react2.default.Component);
	
	CatList.propTypes = {
	    classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(CatList);
	module.exports = exports['default'];

/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(14);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _gatsbyLink = __webpack_require__(67);
	
	var _reactMaterialUiFormValidator = __webpack_require__(562);
	
	var _Button = __webpack_require__(189);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _hmacSha = __webpack_require__(469);
	
	var _hmacSha2 = _interopRequireDefault(_hmacSha);
	
	var _encBase = __webpack_require__(468);
	
	var _encBase2 = _interopRequireDefault(_encBase);
	
	var _CatList = __webpack_require__(720);
	
	var _CatList2 = _interopRequireDefault(_CatList);
	
	var _reactCountdownNow = __webpack_require__(546);
	
	var _reactCountdownNow2 = _interopRequireDefault(_reactCountdownNow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dev = 'http://localhost:4000/site/';
	
	var styles = function styles(theme) {
	  var _singleLineInput;
	
	  return {
	    vbutton: {
	      backgroundColor: theme.main.colors.link,
	      margin: "3em 0"
	    },
	    singleLineInput: (_singleLineInput = {
	      lineHeight: 1.4,
	      fontSize: "1.2em"
	    }, _singleLineInput["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      width: "47%",
	      marginLeft: "3%",
	      "&:first-child": {
	        marginRight: "3%",
	        marginLeft: 0
	      }
	    }, _singleLineInput),
	    err: {
	      color: "red"
	    },
	    success: {
	      background: theme.main.colors.link,
	      color: "white",
	      padding: '.3em',
	      textAlign: 'center',
	      borderRadius: '25px'
	    },
	    blink: {
	      color: theme.main.colors.link
	    },
	    rlink: {
	      color: 'red'
	    }
	  };
	};
	
	var ContactForm = function (_React$Component) {
	  _inherits(ContactForm, _React$Component);
	
	  function ContactForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      sub: {
	        Name: '', Email: '', Categories: ''
	      }, send: {
	        hide: false, err: '', rts: false, success: '', sent: 0
	      }, verify: {
	        err: '', id: '', attempts: 0
	      }
	    }, _this.encrypt = function (code) {
	      _this.token = '';
	      var hash = (0, _hmacSha2.default)(code, _this.props.meta.secret);
	      _this.token = _encBase2.default.stringify(hash);
	    }, _this.startTimer = function () {
	      _this.reset = setTimeout(function () {
	        _this.setState(function (prevState) {
	          return {
	            sub: _extends({}, prevState.sub, {
	              Name: '',
	              Email: ''
	            }),
	            send: _extends({}, prevState.send, {
	              err: 'You were timed out.',
	              success: '',
	              hide: false,
	              rts: false
	            }),
	            verify: _extends({}, prevState.verify, {
	              err: '',
	              id: ''
	            })
	          };
	        });
	      }, 600000);
	    }, _this.stopTimer = function () {
	      clearTimeout(_this.reset);
	    }, _this.countDown = function (_ref) {
	      var minutes = _ref.minutes,
	          seconds = _ref.seconds,
	          completed = _ref.completed;
	
	      if (completed) {
	        return _react2.default.createElement(
	          "span",
	          null,
	          "Please request new ID."
	        );
	      } else {
	        return _react2.default.createElement(
	          "span",
	          null,
	          minutes,
	          ":",
	          seconds
	        );
	      }
	    }, _this.handleCh = function (e) {
	      var value = e.target.value;
	      var name = e.target.name;
	      _this.setState(function (prevState) {
	        var _extends2;
	
	        return {
	          sub: _extends({}, prevState.sub, (_extends2 = {}, _extends2[name] = value, _extends2)),
	          send: _extends({}, prevState.send, {
	            hide: false
	          })
	        };
	      });
	      _this.stopTimer();
	      _this.startTimer();
	    }, _this.addCats = function (selected) {
	      var _this$state$sub = _this.state.sub,
	          Name = _this$state$sub.Name,
	          Email = _this$state$sub.Email;
	
	      if (Name === '' || Email === '') {
	        _this.setState(function (prevState) {
	          return {
	            send: _extends({}, prevState.send, {
	              err: 'Please fill in missing fields',
	              rts: false
	            })
	          };
	        });
	      } else if (selected.length == 0) {
	        _this.setState(function (prevState) {
	          return {
	            send: _extends({}, prevState.send, {
	              err: 'Please select a category',
	              rts: false
	            })
	          };
	        });
	      } else {
	        var strCats = selected.join(' ');
	        _this.setState(function (prevState) {
	          return {
	            send: _extends({}, prevState.send, {
	              rts: true,
	              err: ''
	            }),
	            sub: _extends({}, prevState.sub, {
	              Categories: strCats
	            })
	          };
	        });
	      }
	    }, _this.handleWel = function (e) {
	      e.preventDefault();
	      _this.stopTimer();
	      _this.startTimer();
	      var _this$props$meta = _this.props.meta,
	          server = _this$props$meta.server,
	          welcome = _this$props$meta.welcome;
	      var _this$state = _this.state,
	          send = _this$state.send,
	          sub = _this$state.sub;
	
	      _this.encrypt(sub.Email);
	      if (send.rts) {
	        var welApi = server + welcome;
	        var welPkg = _extends({}, sub);
	        fetch(welApi, {
	          method: "POST",
	          mode: "cors",
	          headers: {
	            "Content-Type": "application/json",
	            'Authorization': "Bearer " + _this.token
	          },
	          body: JSON.stringify(welPkg)
	        }).then(function (res) {
	          if (res.status === 200) {
	            return res.json();
	          } else {
	            _this.setState(function (prevState) {
	              return {
	                send: _extends({}, prevState.send, {
	                  sent: prevState.send.sent + 1,
	                  err: "Connection error (" + res.StatusText + ")"
	                }),
	                verify: _extends({}, prevState.verify, {
	                  err: ''
	                })
	              };
	            });
	          }
	        }).then(function (res) {
	          var r = res.Response;
	          if (r.includes('No')) {
	            _this.setState(function (prevState) {
	              return {
	                send: _extends({}, prevState.send, {
	                  err: r,
	                  sent: prevState.send.sent + 1
	                }),
	                verify: _extends({}, prevState.verify, {
	                  err: ''
	                })
	              };
	            });
	          } else {
	            _this.setState(function (prevState) {
	              return {
	                send: _extends({}, prevState.send, {
	                  success: r,
	                  sent: prevState.send.sent + 1,
	                  hide: true
	                }),
	                verify: _extends({}, prevState.verify, {
	                  err: '',
	                  attempts: 0
	                })
	              };
	            });
	          }
	        }).catch(function (err) {
	          _this.setState(function (prevState) {
	            return {
	              send: _extends({}, prevState.send, {
	                err: "Connection error (" + err.toString() + ")"
	              }),
	              verify: _extends({}, prevState.verify, {
	                err: ''
	              })
	            };
	          });
	        });
	      }
	    }, _this.handleId = function (e) {
	      var value = e.target.value;
	      _this.setState(function (prevState) {
	        return {
	          verify: _extends({}, prevState.verify, {
	            id: value
	          })
	        };
	      });
	      _this.stopTimer();
	      _this.startTimer();
	    }, _this.handleVer = function (e) {
	      e.preventDefault();
	      _this.stopTimer();
	      _this.startTimer();
	      var _this$props$meta2 = _this.props.meta,
	          server = _this$props$meta2.server,
	          addSub = _this$props$meta2.addSub;
	      var verify = _this.state.verify;
	
	      _this.encrypt(verify.id);
	      var verApi = server + addSub;
	      var verPkg = _extends({}, verify);
	      fetch(verApi, {
	        method: "POST",
	        mode: "cors",
	        headers: {
	          "Content-Type": "application/json",
	          'Authorization': "Bearer " + _this.token
	        },
	        body: JSON.stringify(verPkg)
	      }).then(function (res) {
	        if (res.status == 200) {
	          return res.json();
	        } else {
	          _this.setState(function (prevState) {
	            return {
	              verify: _extends({}, prevState.verify, {
	                attempts: prevState.verify.attempts + 1,
	                err: "Connection error (" + res.StatusText + ")"
	              })
	            };
	          });
	        }
	      }).then(function (res) {
	        var r = res.Response;
	        if (r === 'success') {
	          (0, _gatsbyLink.navigateTo)("/subscribed");
	        } else {
	          _this.setState(function (prevState) {
	            return {
	              verify: _extends({}, prevState.verify, {
	                err: r,
	                attempts: prevState.verify.attempts + 1
	              })
	            };
	          });
	        }
	      }).catch(function (err) {
	        _this.setState(function (prevState) {
	          return {
	            verify: _extends({}, prevState.verify, {
	              err: "Connection error (" + err.toString() + ")"
	            })
	          };
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContactForm.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        edges = _props.edges;
	    var _state = this.state,
	        sub = _state.sub,
	        send = _state.send,
	        verify = _state.verify;
	
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Step 1 - Get ID"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        send.sent < 3 ? _react2.default.createElement(
	          _reactMaterialUiFormValidator.ValidatorForm,
	          {
	            onSubmit: this.handleWel,
	            onError: function onError(errs) {
	              return console.log(errs);
	            },
	            name: "send"
	          },
	          send.err && _react2.default.createElement(
	            "p",
	            { className: classes.err },
	            _react2.default.createElement(
	              "strong",
	              null,
	              send.err
	            )
	          ),
	          _react2.default.createElement(_reactMaterialUiFormValidator.TextValidator, {
	            id: "name",
	            name: "Name",
	            label: "Name",
	            value: sub.Name,
	            onChange: this.handleCh,
	            validators: ["required"],
	            errorMessages: ["this field is required"],
	            fullWidth: true,
	            margin: "normal",
	            className: classes.singleLineInput
	          }),
	          _react2.default.createElement(_reactMaterialUiFormValidator.TextValidator, {
	            id: "email",
	            name: "Email",
	            label: "E-mail",
	            value: sub.Email,
	            onChange: this.handleCh,
	            validators: ["required", "isEmail"],
	            errorMessages: ["this field is required", "email is not valid"],
	            fullWidth: true,
	            margin: "normal",
	            className: classes.singleLineInput
	          }),
	          send.hide ? _react2.default.createElement(
	            "div",
	            { className: classes.success },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Check inbox and spam of ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                send.success
	              ),
	              " for email from ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "no-reply@huntcodes.co"
	              )
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Copy ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Subscriber ID"
	              ),
	              " from email and paste below to complete subscription."
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_reactCountdownNow2.default, { date: Date.now() + 420000, renderer: this.countDown })
	            )
	          ) : _react2.default.createElement(_CatList2.default, { add: this.addCats, edges: edges })
	        ) : _react2.default.createElement(
	          "p",
	          { className: classes.err },
	          "We are unable to handle your request at this time. Please ",
	          _react2.default.createElement(
	            "a",
	            { className: classes.rlink, href: "https://www.huntcodes.co/#contact", target: "_blank" },
	            "contact us"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Step 2 - Verify ID"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        " ",
	        verify.attempts < 3 ? _react2.default.createElement(
	          _reactMaterialUiFormValidator.ValidatorForm,
	          {
	            onSubmit: this.handleVer,
	            onError: function onError(errs) {
	              return console.log(errs);
	            },
	            name: "verify"
	          },
	          verify.err && _react2.default.createElement(
	            "p",
	            { className: classes.err },
	            _react2.default.createElement(
	              "strong",
	              null,
	              verify.err
	            )
	          ),
	          _react2.default.createElement(_reactMaterialUiFormValidator.TextValidator, {
	            id: "id",
	            name: "id",
	            label: "Subscriber ID",
	            value: verify.id,
	            onChange: this.handleId,
	            validators: ["required"],
	            errorMessages: ["this field is required"],
	            fullWidth: true,
	            margin: "normal",
	            className: classes.singleLineInput
	          }),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              variant: "raised",
	              color: "primary",
	              size: "large",
	              type: "submit",
	              className: classes.vbutton
	            },
	            "Verify ID"
	          )
	        ) : _react2.default.createElement(
	          "p",
	          { className: classes.err },
	          "We are unable to handle your request at this time. Please ",
	          _react2.default.createElement(
	            "a",
	            { className: classes.rlink, href: "https://www.huntcodes.co/#contact", target: "_blank" },
	            "contact us"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "arthuranteater uses hashed auth tokens, SSL encryption, database encryption, and passkeys on all requests. If you have any concerns or issues signing up, please ",
	        _react2.default.createElement(
	          "a",
	          { className: classes.blink, href: "https://www.huntcodes.co/#contact", target: "_blank" },
	          "contact us"
	        ),
	        "."
	      )
	    );
	  };
	
	  return ContactForm;
	}(_react2.default.Component);
	
	ContactForm.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(ContactForm);
	module.exports = exports["default"];

/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ContactForm = __webpack_require__(721);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ContactForm).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(14);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _reactObfuscate = __webpack_require__(1422);
	
	var _reactObfuscate2 = _interopRequireDefault(_reactObfuscate);
	
	var _ContactForm = __webpack_require__(722);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _Main = __webpack_require__(127);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Article = __webpack_require__(126);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PageHeader = __webpack_require__(153);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(197);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _config = __webpack_require__(88);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {};
	};
	
	var SubscribePage = function SubscribePage(props) {
	  var data = props.data;
	
	  var meta = data.pass.siteMetadata;
	  var edges = data.cat.edges;
	  var filtEdges = edges.filter(function (edge, i) {
	    var cat = edge.node.frontmatter.category;
	    return cat != null;
	  });
	
	  return _react2.default.createElement(
	    _Main2.default,
	    null,
	    _react2.default.createElement(
	      _Article2.default,
	      null,
	      _react2.default.createElement(_PageHeader2.default, { title: "Subscribe" }),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        "Sign up to receive email alerts for new posts!"
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(_ContactForm2.default, { meta: meta, edges: filtEdges })
	    )
	  );
	};
	
	SubscribePage.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(SubscribePage);
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-subscribe-js-8bdd8d2ee824a20eadc7.js